import "style/style.scss";

// @ts-ignore
import AOS from 'aos';
import {domReady} from "@/utils/domReady";
import {SimpleParallax} from "@/components/SimpleParallax";
import {PushToScroll} from "@/components/PushToScroll";
import {Navigation} from "@/components/Navigation";
import {Counter} from "@/components/Counter";
import {Contact} from "@/components/Contact";
import {Accordion} from "@/components/Accordion";
import {SidebarFilter} from "@/components/SidebarFilter";
import Filter from "../js/components/Filter";

domReady(() => {
    // tslint:disable-next-line
    console.log("ready");

    new SimpleParallax();
    new PushToScroll();
    new Navigation();
    new Counter();
    new Contact();
    new Accordion();
    new SidebarFilter();
    new Filter();
    new AOS.init({
        once: true,
    });
});
